export default __webpack_public_path__ + "static/credenzas-881d23681193d84a98991303a807b431.jpg";